import React, { useContext, useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Icon,
  useDisclosure,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useFlowsDispatch } from '../../../../../../../common/src/utils/globalVariables';
import useFlowsResetState from '../../../../../hooks/useFlowsResetState';
import { setLastPosition } from '../../../../../store/redux/slices/flowsMetaDataSlice';
import { ThemeContext } from 'styled-components';

const NewConversationButton: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const cancelRef = useRef(null);
  const dispatch = useFlowsDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { reset } = useFlowsResetState();
  // not using useTheme because the need of 'isImmo' prop from the theme
  const theme = useContext(ThemeContext);

  const handleNewConversation = () => {
    reset();
    dispatch(setLastPosition(0));
    history.push('/');
  };

  return (
    <>
      <Box pr="4">
        <Button
          w="100%"
          minH="10"
          variant="link"
          mr="4"
          color={theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]}
          leftIcon={<Icon name="GeneralNavigationNewConversation" />}
          onClick={onOpen}
        >
          {t('NEW-CALCULATION')}
        </Button>
      </Box>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {t('NEW-CALCULATION')}
            </AlertDialogHeader>
            <AlertDialogBody>
              {t('SALES-CONVERSATION_OFFERS_NEW-CONVERSATION_ALERT_BODY')}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="grayedGhost" ref={cancelRef} onClick={onClose}>
                {t('CANCEL')}
              </Button>
              <Button
                colorScheme="red"
                onClick={handleNewConversation}
                ml={3}
                rightIcon={<Icon name="GeneralActionsArrowRight" />}
              >
                {t('NEW-CALCULATION-START')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default NewConversationButton;
